const printOfferModalInitialState = {
  printOfferModal: {
    isOpened: false,
    offerId: '',
    subSystemNames: [],
  },
}

const printOfferModalReducer = {
  showPrintOfferModal: (state, { payload }) => {
    state.printOfferModal = {
      ...payload,
      isOpened: true,
    }
  },
  hidePrintOfferModal: (state) => {
    state.printOfferModal = {
      isOpened: false,
      offerId: '',
      subSystemNames: [],
    }
  },
}

const selectPrintOfferModal = (state) => state.offers.printOfferModal

export { printOfferModalInitialState, printOfferModalReducer, selectPrintOfferModal }
